import { render } from "./ProductShare.vue?vue&type=template&id=e1d6a956"
import script from "./ProductShare.vue?vue&type=script&lang=js"
export * from "./ProductShare.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/teslaelectric-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__